import Vue from 'vue';

import BreadcrumbComponent from '@/components/standard/BreadcrumbComponent.vue';
import ButtonComponent from '@/components/standard/ButtonComponent.vue';
import CheckboxGroupInputComponent from '@/components/standard/CheckboxGroupInputComponent.vue';
import CheckboxInputComponent from '@/components/standard/CheckboxInputComponent.vue';
import ChipComponent from '@/components/standard/ChipComponent.vue';
import CollapseComponent from '@/components/standard/CollapseComponent.vue';
import DatePickerComponent from '@/components/standard/DatePickerComponent.vue';
import DropdownComponent from '@/components/standard/DropdownComponent.vue';
import GridTableComponent from '@/components/standard/GridTableComponent.vue';
import ModalComponent from '@/components/standard/ModalComponent.vue';
import NumberInputComponent from '@/components/standard/NumberInputComponent.vue';
import RadioButtonComponent from '@/components/standard/RadioButtonComponent.vue';
import SelectFilterComponent from '@/components/standard/SelectFilterComponent.vue';
import StepByStepComponent from '@/components/standard/StepByStepComponent.vue';
import SubtitleComponent from '@/components/standard/SubtitleComponent.vue';
import TitleComponent from '@/components/standard/TitleComponent.vue';
import TextAreaInputComponent from '@/components/standard/TextAreaInputComponent.vue';
import TextInputComponent from '@/components/standard/TextInputComponent.vue';

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)
Vue.component('breadcrumb-component', BreadcrumbComponent);
Vue.component('button-component', ButtonComponent);
Vue.component('checkbox-group-input-component', CheckboxGroupInputComponent);
Vue.component('checkbox-input-component', CheckboxInputComponent);
Vue.component('chip-component', ChipComponent);
Vue.component('collapse-component', CollapseComponent);
Vue.component('date-picker-component', DatePickerComponent);
Vue.component('dropdown-component', DropdownComponent);
Vue.component('grid-table-component', GridTableComponent);
Vue.component('modal-component', ModalComponent);
Vue.component('number-input-component', NumberInputComponent);
Vue.component('radio-button-component', RadioButtonComponent);
Vue.component('select-filter-component', SelectFilterComponent);
Vue.component('step-by-step-component', StepByStepComponent);
Vue.component('subtitle-component', SubtitleComponent);
Vue.component('title-component', TitleComponent);
Vue.component('text-area-input-component', TextAreaInputComponent);
Vue.component('text-input-component', TextInputComponent);
